import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NetPriceLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.product.validation.net-price.less-than-zero-error');
    }
}
